<template>
	<div class="modal" v-bind:class="{ open: showmodal }">
		<div class="modal__backdrop" v-on:click="hideModal"></div>
			<div class="modal__dialog">
			<div class="modal__content">
			  <p>
				Η τέχνη της χαρακτικής ξεκινά από το σχέδιο, όπως και η ζωγραφική. Με τον όρο χαρακτική εννοούμε όλες τις διαδικασίες που ακολουθεί ο χαράκτης για να μεταφέρει μια σύνθεση που έχει προσχεδιάσει, σε μία επιφάνεια ξύλου, χαλκού, πέτρας ή άλλου υλικού (χαρακτική πλάκα) και έπειτα να την τυπώσει, συνήθως, σε χαρτί. </p>
				<p>
				Η τέχνη της χαρακτικής και οι διάφορες τεχνικές της μας εισήγαγαν στην έννοια του πολλαπλού, αφού προσέφεραν τη δυνατότητα αναπαραγωγής ενός έργου σε πολλά αντίτυπα, τα χαρακτικά. Ωστόσο ένα χαρακτικό -ιδίως σήμερα- μπορεί να είναι μοναδικό (το λεγόμενο μονότυπο/monoprint). Ο χαράκτης αποφασίζει για τον αριθμό αντιτύπων που θα φτιάξει και αριθμεί καθένα από αυτά.</p>
				<p>
				Τα πρώτα χαρακτικά ήταν ξυλογραφίες που εμφανίστηκαν στην Κίνα τον 9ο αιώνα, ενώ στην Ευρώπη διαδόθηκαν τον 14ο αιώνα. Ακολουθούν οι χαλκογραφίες περί τα μέσα του 15ου αιώνα. Στην Ελλάδα, η πορεία ήταν αντίστροφη. Εδώ, τα πρώτα χαρακτικά που τυπώθηκαν ήταν χαλκογραφίες, ενώ οι ξυλογραφίες ήρθαν αργότερα. Η χαρακτική τέχνη θα καθιερωθεί στην Ελλάδα στις αρχές της δεκαετίας του 1930 με την επανέναρξη της διδασκαλίας της χαρακτικής από τον Γιάννη Κεφαλληνό στην Ανωτάτη Σχολή Καλών Τεχνών, έπειτα από περίπου 15 έτη διακοπής. </p>
				<p> Με την εξέλιξη της τεχνολογίας η τέχνη της χαρακτικής αποκτά ολοένα και δυναμικότερο χαρακτήρα, με τους χαράκτες να πειραματίζονται σε νέα υλικά και να συνδυάζουν διάφορες τεχνικές, διευρύνοντας ακόμα περισσότερο το πεδίο έκφρασής της. 
			  </p>
			  <a href="#" v-on:click="hideModal" class="close-modal"><img src="../assets/img/close.svg" alt=""></a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'modal',
	props: [ 'title', 'showmodal' ],
	methods: {
	    hideModal: function (event) {
	      event.preventDefault();
	      this.$emit('hideModal', event)
	    }
  	}
}	
</script>



// WEBPACK FOOTER //
// Modal.vue?6704f95d